import { render, staticRenderFns } from "./dic_type_list.vue?vue&type=template&id=793f42ac&scoped=true"
import script from "./dic_type_list.vue?vue&type=script&lang=js"
export * from "./dic_type_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793f42ac",
  null
  
)

export default component.exports